import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { Provider } from 'react-redux';
import { I18nextProvider } from 'react-i18next';
import configureStore from './store';
import marketingI18n, { fetchTranslations } from './marketing/i18n';
import 'bootstrap/dist/css/bootstrap.css';

const store = configureStore();

async function startApp() {
  await fetchTranslations();

  ReactDOM.render(
    <Provider store={store}>
      <I18nextProvider i18n={marketingI18n}>
        <React.StrictMode>
          <App />
        </React.StrictMode>
      </I18nextProvider>
    </Provider>,
    document.getElementById('root')
  );
}

startApp();

reportWebVitals();
